import { ArrowLeft, PanelRight } from "lucide-react";
import type { ReactNode } from "react";

import { PanelHeader } from "@/components/ui/panel";
import type { ConversaUnificada } from "@/lib/types";

import { SeloDoCanal } from "./selo-do-canal";
import { IconButton } from "@/components/ui/icon-button";

export const ROTULO_DO_STATUS: Record<NonNullable<ConversaUnificada["status"]>, string> = {
  open: "Aberta",
  pending: "Pendente",
  snoozed: "Adiada",
  resolved: "Resolvida",
};

/**
 * TUT-491 — o topo da conversa aberta, igual nas três fontes. TUT-590 — na
 * janela do chat rápido, sem "Voltar" nem "Contato e processo": as ações são
 * as da janela (`acoes`), e o título leva o id da janela (cabem três).
 */
export function CabecalhoDaConversa({
  conversa,
  subtitulo,
  onVoltar,
  onContato,
  acoes,
  idDoTitulo = "conversa-aberta",
}: {
  conversa: ConversaUnificada;
  subtitulo: string;
  onVoltar?: () => void;
  onContato?: () => void;
  acoes?: ReactNode;
  idDoTitulo?: string;
}) {
  return (
    <PanelHeader className="items-start gap-3">
      <div className="flex min-w-0 items-center gap-2">
        {onVoltar ? (
          <IconButton
            label="Voltar para as conversas"
            icone={<ArrowLeft aria-hidden="true" />}
            onClick={onVoltar}
            className="lg:hidden"
          />
        ) : null}
        <div className="min-w-0">
          <h2 id={idDoTitulo} className="truncate" tabIndex={-1}>
            {conversa.titulo}
          </h2>
          <p className="m-0 mt-1 flex flex-wrap items-center gap-2 text-legenda text-[var(--muted)]">
            <SeloDoCanal canal={conversa.canal} rotulo={conversa.canalRotulo} />
            {conversa.status ? <span>{ROTULO_DO_STATUS[conversa.status]}</span> : null}
            <span className="min-w-0 truncate">{subtitulo}</span>
          </p>
        </div>
      </div>
      {onContato ? (
        <IconButton
          label="Contato e processo"
          icone={<PanelRight aria-hidden="true" />}
          onClick={onContato}
          className="xl:hidden"
        />
      ) : null}
      {acoes ? <div className="flex shrink-0 items-center gap-0.5">{acoes}</div> : null}
    </PanelHeader>
  );
}
